var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-recaptcha',{ref:"recaptcha",staticClass:"demo-recaptcha",attrs:{"sitekey":_vm.keyRecaptcha,"size":"invisible","load-recaptcha-script":true,"recaptcha-host":"www.recaptcha.net"},on:{"verify":_vm.onVerify,"error":_vm.onRecaptchaError,"expired":_vm.onExpired,"render":_vm.onRender}})
}
var staticRenderFns = []

export { render, staticRenderFns }